// extracted by mini-css-extract-plugin
export default {"container":"FulfillmentCenterSelect_container__vrz1-"};